import getFormDataFromObject from "../helpers/getFormDataFromObject";
import { addTrail } from "../trail";

/**
   * Creates a new file
   * @function Main.createFile
   * @param  {Object} nodeData {
   *    path: 'templates/test.liquid',
        reference: 'test.liquid',
        file_type: 'template',
        content: 'code'
      }
   * @param {function} callback
   * @param {function} callback_2 an optional callback if there's content to be added
   * @return {type} {description}
   */
export default async (nodeData, callback = () => {}, callback_2 = () => {}) => {
  const { content = null, blob, ...file } = nodeData;
  try {
    const request = await fetch("/api/v1/code_editor/", {
      method: "POST",
      headers: {
        "x-csrf-token": $("meta[name='csrf-token']").attr("content")
      },
      credentials: "include",
      body: getFormDataFromObject({
        ...file,
        path: nodeData.path || "templates/untitled.liquid",
        reference: nodeData.reference || "untitled.liquid",
        file_type: nodeData.file_type || "template",
        rename: true,
        folder: false,
        content,
        extension: nodeData.path.split(".").pop() || "",
        theme_id: CodeEditor.Main.themeId(),
        socket_id: window.socketId
      })
    });

    const data = await request.json();

    const { success, file_type, title, reference } = data;
    if (!success) {
      console.error("failed to process a callback to the caller 😱 , see above trace ");
      console.error(nodeData);
      console.error(data);
      return typeof nodeData.fail == "function" && nodeData.fail();
    }
    addTrail(`Created File "${reference}"`);
    if (file_type === "asset") data.reference = reference + "." + title.split(".").pop();
    if (!content) return null;
    await new Promise((resolve, reject) => {
      CodeEditor.Main._passiveSave({ ...data, content }).then(
        () => {
          typeof nodeData.contentAdded == "function" && nodeData.contentAdded();
          callback_2();
          resolve();
        },
        error => {
          console.log("err:: cannot add content to " + reference, error);
          reject(error);
        }
      );
    });

    typeof nodeData.success == "function" && nodeData.success();
    callback();
    return true;
  } catch (error) {
    console.error("couldn't create file due to error" + error);
    console.error(nodeData);
    typeof nodeData.error == "function" && nodeData.error();
    return false;
  }
};
